export const environment = {
    production: true,
    merchantId: 'TEST222204660001',
    hmr: false,
    apiUrl: '/api/',
    signalRServer: ''
};
